// Message.js
import React, { useState, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';

const MessageContainer = ({ message, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(false);
    }, 1800);
    const timer = setTimeout(() => {
      onClose();
    }, 2000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className={`z-[99] fixed top-10 left-0 right-0 flex justify-center transition-opacity duration-300 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="flex items-center p-2 bg-white text-black rounded-md shadow-lg">
        <i className="icon-24-success-mono mr-2 text-[#52c41a]" />
        {message}
      </div>
    </div>
  );
};

export const useMessage = () => {
  const [isMessageVisible, setMessageVisible] = useState(false);
  const [messageContent, setMessageContent] = useState('');

  const showMessage = useCallback((message) => {
    setMessageContent(message);
    setMessageVisible(true);
  }, []);

  const hideMessage = useCallback(() => {
    setMessageVisible(false);
    setMessageContent('');
  }, []);

  const MessageComponent = isMessageVisible
    ? ReactDOM.createPortal(<MessageContainer message={messageContent} onClose={hideMessage} />, document.body)
    : null;

  return { MessageComponent, showMessage };
};
